import ScoreCircle from './ScoreCircle';
import ScoreDescription from './ScoreDescription';
import { NoScore, NoScoreCaption } from './ProUpgrade';
import { getScoreColor, getScoreLabel } from '../lib/score';

/**
 * The top of every practice result: the score, its label ("Great!") and what
 * it means ("Very good and clearly understandable."), or the padlock when the
 * free allowance is used up. ONE component for Manual, Automatic and Quick
 * Practice (Leanne, 19 Oct 2026), so the modes cannot show it differently
 * again. Renders nothing when there is no score (a cut-off recording).
 */
export default function ScoreHeader({ score, locked = false, onUpgrade, className = 'mb-8' }) {
    if (locked) {
        return (
            <div className={`text-center ${className}`}>
                <div className="inline-flex flex-col items-center gap-2 mb-1">
                    <NoScore onClick={onUpgrade} />
                </div>
                <NoScoreCaption onUpgrade={onUpgrade} />
            </div>
        );
    }
    if (score == null) return null;
    return (
        <div className={`text-center ${className}`} data-testid="score-header">
            <div className="inline-flex flex-col items-center gap-2 mb-1">
                <ScoreCircle score={score} suffix="%" />
            </div>
            <p className={`text-xl font-semibold ${getScoreColor(score)}`}>
                {Math.round(score) === 100 ? 'Perfect!' : getScoreLabel(score)}
            </p>
            <ScoreDescription score={score} />
        </div>
    );
}
